export default __webpack_public_path__ + "static/media/MSC Cruises - Logo2.e344160c.png";